import * as React from 'react';
import { EPercentVisible } from '../../constants/percentVisible';
import { createChild } from './internal/createChild';
import { useGetCallback } from './internal/useGetCallback';
import { DEFAULT_CALLBACK_DELAY } from '../../constants/defaultCallbackDelay';
import { useInView } from './internal/useInView';
export var ActionAfterViewObserver = function ActionAfterViewObserver(props) {
  var _props$percentVisible = props.percentVisible,
    percentVisible = _props$percentVisible === void 0 ? EPercentVisible.Percent50 : _props$percentVisible,
    _props$callbackDelay = props.callbackDelay,
    callbackDelay = _props$callbackDelay === void 0 ? DEFAULT_CALLBACK_DELAY : _props$callbackDelay,
    trackVisibility = props.trackVisibility,
    _props$triggerOnce = props.triggerOnce,
    triggerOnce = _props$triggerOnce === void 0 ? true : _props$triggerOnce;
  var timerRef = React.useRef();
  var _useInView = useInView({
      threshold: percentVisible,
      /** Для IntersectionObserver мы всегда выключаем опцию triggerOnce, т.к без этого не получится сделать отмену вызова по таймеру */
      triggerOnce: false,
      trackVisibility: trackVisibility,
      delay: trackVisibility ? 150 : undefined
    }),
    ref = _useInView.ref,
    inView = _useInView.inView,
    entry = _useInView.entry;
  var callback = useGetCallback(props.callback, triggerOnce);
  React.useEffect(function () {
    if (inView) {
      /**
       * Если элемент попал в вьюпорт и продолжает в нем быть,
       * то через время callbackDelay вызовется коллбэк
       * */
      timerRef.current = window.setTimeout(function () {
        /**
         * Если отслеживается видимость, нужно так же проверить, чтоб блок был видимым
         * Фича IntersectionObserver v2
         * */
        /* istanbul ignore next не получается покрыть через тесты */
        if (!trackVisibility || entry !== null && entry !== void 0 && entry.isVisible) {
          callback();
        }
        clearTimeout(timerRef.current);
        timerRef.current = undefined;
      }, callbackDelay);

      /**
       * В случае, когда inView меняется с false на true (элемент появляется), запланируем отмену setTimeout
       * Т.е когда inView изменится обратно с true на false (элемент скроется), setTimeout отменится
       * Это нужно, чтоб коллбэк не вызвался, если не прошло необходимое время (callbackDelay)
       * */
      return function () {
        clearTimeout(timerRef.current);
        timerRef.current = undefined;
      };
    } else {
      /** В случае, когда inView меняется с true на false, нам не нужно планировать отмену таймера */
      return undefined;
    }
  }, [callback, entry, inView, callbackDelay, trackVisibility]);
  return createChild(props, ref);
};
ActionAfterViewObserver.displayName = 'ActionAfterViewObserver';